import { render, staticRenderFns } from "./NotificationDataCheckinJobIcon.vue?vue&type=template&id=b644b0f0&"
import script from "./NotificationDataCheckinJobIcon.vue?vue&type=script&lang=ts&"
export * from "./NotificationDataCheckinJobIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports